"use strict";
// tslint:disable
// eslint-disable
/**
 * API Key Management API
 * API for CRUDing API Keys
 *
 * The version of the OpenAPI document: 1.0.3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var runtime_1 = require("../runtime");
var _1 = require("./");
function ApiKeyFromJSON(json) {
    return ApiKeyFromJSONTyped(json, false);
}
exports.ApiKeyFromJSON = ApiKeyFromJSON;
function ApiKeyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'keyName': json['keyName'],
        'keyId': !runtime_1.exists(json, 'keyId') ? undefined : json['keyId'],
        'keySecret': !runtime_1.exists(json, 'keySecret') ? undefined : json['keySecret'],
        'createdAtTimestamp': !runtime_1.exists(json, 'createdAtTimestamp') ? undefined : new Date(json['createdAtTimestamp']),
        'lastUsedAtTimestamp': !runtime_1.exists(json, 'lastUsedAtTimestamp') ? undefined : new Date(json['lastUsedAtTimestamp']),
        'deletedAtTimestamp': !runtime_1.exists(json, 'deletedAtTimestamp') ? undefined : new Date(json['deletedAtTimestamp']),
        'owner': !runtime_1.exists(json, 'owner') ? undefined : _1.KeyOwnerFromJSON(json['owner']),
    };
}
exports.ApiKeyFromJSONTyped = ApiKeyFromJSONTyped;
function ApiKeyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'keyName': value.keyName,
        'keyId': value.keyId,
        'keySecret': value.keySecret,
        'createdAtTimestamp': value.createdAtTimestamp == null ? undefined : value.createdAtTimestamp.toISOString(),
        'lastUsedAtTimestamp': value.lastUsedAtTimestamp == null ? undefined : value.lastUsedAtTimestamp.toISOString(),
        'deletedAtTimestamp': value.deletedAtTimestamp == null ? undefined : value.deletedAtTimestamp.toISOString(),
        'owner': _1.KeyOwnerToJSON(value.owner),
    };
}
exports.ApiKeyToJSON = ApiKeyToJSON;
